<template>
    <div class="border-b border-border py-4 flex justify-between">
        <component :is="'p'" class="text-2xl font-semibold" v-text="this.$lang.get('Sort groups')" />
        <div class="flex justify-end">
            <Tooltip>
                <template #trigger>
                    <button :class="[`
                    text-${model}-accent
                    hover:bg-${model}-accent hover:text-${model}
                    transition duration-button-hover
                    p-1.5 rounded-full`]" @click="onSave">
                        <PhFloppyDisk class="size-6" />
                    </button>
                </template>
                <template #content>
                    <p :class="`bg-tooltip ring-1 py-1 px-3 font-medium text-tooltip-text shadow w-max ring-tooltip-border-inverted rounded-lg`"
                        v-text="this.$lang.get('Save sort order')" />
                </template>
            </Tooltip>
            <Tooltip>
                <template #trigger>
                    <button :class="[`
                    text-${model}-accent
                    hover:bg-${model}-accent hover:text-${model}
                    transition duration-button-hover
                    p-1.5 rounded-full`]" @click="goBack">
                        <PhX class="size-6" />
                    </button>
                </template>
                <template #content>
                    <p :class="`bg-tooltip ring-1 py-1 px-3 font-medium text-tooltip-text shadow w-max ring-tooltip-border-inverted rounded-lg`"
                        v-text="this.$lang.get('Cancel edit mode')" />
                </template>
            </Tooltip>
        </div>
    </div>

    <VueDraggable v-model="this.groups"
        class=" flex flex-col gap-2 mt-4 p-4 w-300px h-300px m-auto bg-gray-500/5 rounded" @end="onEnd">
        <div v-for="group in groups">
            <div
                class="border-b border-border py-4 flex justify-between bg-gray-700/5 rounded mt-2 mb-2 cursor-grab p-4">
                <p class="text-2xl font-semibold" v-text="group.title" />

            </div>
        </div>
    </VueDraggable>
</template>

<script>
import { VueDraggable } from 'vue-draggable-plus'
import {
    PhFloppyDisk,
    PhX
} from '@phosphor-icons/vue'
import Tooltip from '@/Components/Elements/Tooltip.vue'

export default {
    name: 'DraggableGroupPanel',
    emits: ['cancelEditSortGroups', 'update:modelValue'],
    components: {
        VueDraggable,
        PhX,
        PhFloppyDisk,
        Tooltip
    },

    props: {
        model: {
            type: String,
            required: true
        },
        modelValue: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            groups: this.modelValue,
        }
    },

    methods: {
        goBack() {
            this.$emit('cancelEditSortGroups')
        },

        updateModelValue(groups) {
            this.$emit('update:modelValue', groups)
        },

        onEnd(event) {
            this.groups.map(function (value, index) {
                value.sort_order = index
                return value
            })
        },

        onSave() {
            const data = this.groups.map((value, index) => {
                return { id: value.id, sort_order: index }
            })


            axios
                .patch(
                    this.route('api.resources.sort_groups'),
                    {
                        groups: data,
                    }
                )
                .then(({ data }) => {
                })

            this.updateModelValue(this.groups)
            this.goBack()
        }
    }
}
</script>
